import { InvoicePaymentMethod } from '@css-xp/graphtypes/src/generated-types-new';
import { InvoiceWithLineItems } from '@atlassian/cssxp-types-billing';
import * as InvoiceUtils from '@atlassian/cssxp-utils-invoice';
import React from 'react';
import './invoice-payment-details.scss';

const CONTAINER_TEST_ID = 'invoice-payment-details';

const InvoicePaymentDetails = ({
  paymentMethod,
  creditCard,
  paypalAccountEmail,
  transactionAccountId,
}: InvoiceWithLineItems) => {
  const isTermPayment = ['PAID_ON_TERMS', 'PAID', 'PAID_BANK', 'PAIDONACCOUNT', 'DEFERRED'].includes(
    paymentMethod || ''
  );

  if (!paymentMethod || !transactionAccountId) {
    return null;
  }

  if (InvoiceUtils.isPaidByCreditCard(paymentMethod)) {
    const last4Numbers = creditCard.last4Numbers ? `**** **** **** ${creditCard.last4Numbers}` : '';
    const brand = creditCard.brand ? `(${creditCard.brand})` : '';
    return (
      <div className="invoice-payment-details-container" data-testid={CONTAINER_TEST_ID}>
        <div className="payment-method">
          <p className="payment-label">Payment method</p>
          <p>{InvoiceUtils.getHumanReadableNameFromPaymentMethod(paymentMethod)}</p>
        </div>
        <div className="card-number">
          <p className="payment-label">Card number</p>
          <p>{`${last4Numbers} ${brand}`}</p>
        </div>
        <div className="card-holder">
          <p className="payment-label">Card holder</p>
          <p>{creditCard.cardHolderName}</p>
        </div>
        <div className="card-expiry">
          <p className="payment-label">Card expiry</p>
          <p>
            {creditCard.expirationMonth && creditCard.expirationYear
              ? `${creditCard.expirationMonth}/${creditCard.expirationYear}`
              : 'Not Available'}
          </p>
        </div>
      </div>
    );
  }

  if (isTermPayment) {
    return (
      <div className="invoice-term-payment-details-container" data-testid={CONTAINER_TEST_ID}>
        <div className="term-payment-method">
          <p className="term-payment-label">Payment method</p>
          <p>Payment terms</p>
        </div>
      </div>
    );
  }

  if (paymentMethod === InvoicePaymentMethod.PAIDPAYPAL) {
    return (
      <div className="invoice-payment-details-container" data-testid={CONTAINER_TEST_ID}>
        <div className="payment-method">
          <p className="payment-label">Payment method</p>
          <p>{InvoiceUtils.getHumanReadableNameFromPaymentMethod(paymentMethod)}</p>
        </div>
        <div className="paypal-email">
          <p className="payment-label">Paypal account</p>
          <p>{paypalAccountEmail}</p>
        </div>
      </div>
    );
  }

  return null;
};

export default InvoicePaymentDetails;
